import React, { useEffect, useState } from "react";
import { getStorageUser } from "../../../helpers/api_helper";
import {
  Button,
  Col,
  Container,
  Form,
  Spinner,
} from "reactstrap";
import Select from "react-select";
import { useFormik } from "formik";
import * as Yup from "yup";
import Breadcrumb from "../../../components/Common/Breadcrumb";
import {
  getRouteConfigs,
  postImage,
  postRouteConfig,
  resourcesConcesionarios,
} from "../../../helpers/backend_helper";

import { ROUTES_CONFIGS } from "../../../constants/routeConfigs";
import NibbleInput from "../../../components/Fields/NibbleInput";
import ConcesionariosNotificationTable from "./ConcesionariosNotificationTable";
import { PROFILES } from "../../../components/VerticalLayout/SidebarContent";

const reportNotificationList = [
  { id: "", name: "Seleccionar..." },
  {
    id: ROUTES_CONFIGS.NOTIFICATION_DAILY_SUMMARY_REPORT,
    name: "Resumen del día concesionarios",
  },
  {
    id: ROUTES_CONFIGS.NOTIFICATION_PASAJE_DAILY_SUMMARY_REPORT,
    name: "Resumen pasaje del día concesionarios",
  },
];

export const findValue = (resource, id) => {
  return resource.filter((e) => e.configuration_id == id)[0]?.value ?? "";
};

const getImage = (resource, id) =>
  resource.find((item) => item.configuration_id === id)?.image;

const ConfigurationNotifications = () => {
  const title = "Notificaciones";

  const user = getStorageUser();

  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [concesionariosModal, setConcesionariosModal] = useState({
    show: false,
  });

  const [concesionarios, setConcesionarios] = useState([]);

  const fetchConfigs = async () => {
    const resource = await getRouteConfigs();

    const notificationDailyReportValue = findValue(
      resource,
      ROUTES_CONFIGS.NOTIFICATION_DAILY_SUMMARY_REPORT
    );

    validation.setFieldValue(ROUTES_CONFIGS.NOTIFICATION_DAILY_SUMMARY_REPORT,
      notificationDailyReportValue
        ? JSON.parse(notificationDailyReportValue)
        : "",
    );

    const notificationDailyReportValue2 = findValue(
      resource,
      ROUTES_CONFIGS.NOTIFICATION_PASAJE_DAILY_SUMMARY_REPORT
    );

    validation.setFieldValue(ROUTES_CONFIGS.NOTIFICATION_PASAJE_DAILY_SUMMARY_REPORT,
      notificationDailyReportValue2
        ? JSON.parse(notificationDailyReportValue2)
        : "",
    );

    const image = getImage(resource, ROUTES_CONFIGS.LOGO_FILE);

    setImage(image);
  };

  useEffect(() => {
    const loadConf = async () => {
      setLoading(true);
      await fetchConfigs();
      setLoading(false);
    };
    loadConf();
  }, []);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      report_notifications: "",
    },
    validationSchema: Yup.object({
      report_notifications: Yup.string().nullable(true),
    }),
    onSubmit: async (values) => {
      await save(values);
    },
  });

  const toggleModal = () => {
    setConcesionariosModal({ show: !concesionariosModal.show });
    validation.setFieldValue("report_notifications", "");
  };

  const save = async (data) => {
    try {
      const cleanData = {
        //..._.omit(data, ["report_notifications"]), //solo para seleccionar el tipo de reporte
        [data["report_notifications"]]: data["report_notifications"]
          ? JSON.stringify(data[data["report_notifications"]])
          : "",
      };

      setLoadingBtn(true);
      const response = await postRouteConfig(cleanData);

      toggleModal();

      await fetchConfigs();
    } catch (err) {
      console.error(err);
    }
    setLoadingBtn(false);
  };

  const handleOpenConcesionariosModal = () => {
    if (validation.values.report_notifications) {
      setConcesionariosModal({ show: true });
    }
  };

  useEffect(handleOpenConcesionariosModal, [
    validation.values.report_notifications,
  ]);

  useEffect(() => {
    const getConcesionarios = async () => {
      let params = { params: { select: true } };
      const response = await resourcesConcesionarios("get", params);

      setConcesionarios(response.data);
    };
    getConcesionarios();
  }, []);

  document.title = "Configuración de Ruta | Sistema de logística";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="">
            <div className="card">
              <div className="card-header">
                <Breadcrumb title={title} breadcrumbItem={title} />
              </div>
              <div className="card-body">
                {loading}
                {loading && <Spinner size="sm"></Spinner>}
                {!loading && (
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <div className="row">
                      {[PROFILES.Administrador].includes(user.profile_id) && (
                        <NibbleInput
                          md={4}
                          label="Seleccionar reporte:"
                          fieldName="report_notifications"
                          fieldType="select"
                          selectItems={reportNotificationList}
                          validation={validation}
                        />
                      )}

                      <Col md={12} className="text-center mt-3">
                        <Button
                          color="primary"
                          type="submit"
                          disabled={loadingBtn || validation.values.report_notifications == ""}
                        >
                          {loadingBtn && <Spinner size="sm"></Spinner>}{" "}
                          <i className="fa fa-save"></i> Guardar
                        </Button>{" "}
                      </Col>
                    </div>
                  </Form>
                )}
              </div>
            </div>
          </div>
          {concesionariosModal.show && (
            <ConcesionariosNotificationTable
              modal={concesionariosModal}
              setModal={setConcesionariosModal}
              validation={validation}
              concesionarios={concesionarios}
              reportNotificationList={reportNotificationList}
            />
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ConfigurationNotifications;
